class ResponsiveBackgroundImage {
  constructor(element) {
    this.element = element;
    this.img = element.querySelector('img');
    this.src = '';

    this.img.addEventListener('load', () => {
      this.update();
    });

    if (this.img.complete) {
      this.update();
    }
  }

  update() {
    const src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
    if (this.src !== src) {
      this.src = '';
      // eslint-disable-next-line
      this.element.style.backgroundImage = 'url("' + src + '")';
    }
  }
}

export default function initResponsiveBackgroundImages() {
  const elements = document.querySelectorAll('[data-responsive-background-image]');
  for (let i = 0; i < elements.length; i += 1) {
    new ResponsiveBackgroundImage(elements[i]);
  }
}
